import type { FaireProductEntity } from "../../entity_types/product";

export const p_8w6akdvjq7: FaireProductEntity = {
  token: "p_8w6akdvjq7",
  type: "product",
  name: "ROOM SPRAY | 4 OZ",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/a1ed04f1d83cf5b80790f70579f872fb06a3afe2380c49483fcbc2bae840382b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4aa06c141e15304937a694b1a612419873499f63cf778355138c39adbe5450f.png",
    "https://cdn.faire.com/fastly/f7ec91634abe858ed1431866fd01af1e72e3d1ea2e7757e6d7c0e89d9e10aec0.png",
  ],
  priceDollars: 18.2,
  description:
    'Getting rid of false fragrances but still want your house to smell good? Then you will love these all-natural room sprays.\n\nTO USE: Shake well. Spray liberally in room, car, or anywhere as needed.\n\nLEMON + ORANGE \nINGREDIENTS: DISTILLED WATER, ISOPROPYL ALCOHOL,100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: GRAPEFRUIT, ORANGE, LIME, LEMON.\n \nGRAPEFRUIT + LEMONGRASS \nINGREDIENTS: DISTILLED WATER, ISOPROPYL ALCOHOL,100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: GRAPEFRUIT, BERGAMOT, LEMONGRASS. \n\nROSEMARY + LEMONGRASS \nINGREDIENTS: DISTILLED WATER, ISOPROPYL ALCOHOL,100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: ROSEMARY, PEPPERMINT, LEMONGRASS.\n\nDimension: 4 oz, 1.9" x 4.4" x 1.9".',
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:55.508Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
